import { render, staticRenderFns } from "./ReferralsInvite.vue?vue&type=template&id=ddfdcc3a&"
import script from "./ReferralsInvite.vue?vue&type=script&lang=js&"
export * from "./ReferralsInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports